<template>
	<div class="wrapper">
		<div class="" style="height: 65.7vh;overflow-y: auto;">
			<!-- <div id="previewPdf"></div> -->
			<!-- <embed style="background-color: #FFFFFF;" :src="pdfUrl" type="application/pdf" width="100%" height="600px" /> -->
			<div class=""
				style="display: flex;align-items: center;justify-content: center;width: 100%;height: auto;background-color: #FFFFFF;position: relative;">
				<div class="" style="width: 50%;height: auto;padding: 20px 0px;">
					<div class="" style="width: 100%;box-shadow: 0px 0px 3px 3px #dddddd;position: relative;">
						<div class="" style="position: absolute;top: 0px;left: -107px;">
							<el-button @click="downloadPDF('1')">下 载 证 书</el-button>
						</div>
						<pdf-viewer :src="pdfUrl1"></pdf-viewer>
					</div>
					<div id="" style="position: relative;height:100%;">
						 <div class="" style="position: absolute;top: 0px;left: -107px;">
						 	<el-button @click="downloadPDF('2')">下 载 文 件</el-button>
						 </div>
						 <div v-for="(item,index) in numPages" class=""
						 	style="width: 100%;box-shadow: 0px 0px 3px 3px #dddddd;margin-top: 20px;">
						 	<pdf-viewer style="margin-bottom: 20px;" :src="pdfUrl2" :page="(index+1)"> </pdf-viewer>
						 </div>
					</div>
					

				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import PdfViewer from 'vue-pdf';
	import {
		saveAs
	} from 'file-saver';
	import {
		getMeetingRecord
	} from '@/serve/meeting';
	// import pdfh5 from 'pdfh5';
	// import 'pdfh5/css/pdfh5.css'
	export default {
		name: 'pdfh5',
		components: {
			PdfViewer
		},
		props: {
			getMeetingRecordRes: Object,
			name: String,
		},
		data() {
			return {
				pdfh5: null,
				pdfUrl1: "",
				pdfUrl2: '',
				page: 2,
				numPages:0,
			};
		},
		watch: {
			getMeetingRecordRes(res) {
				console.log("jin", res)
				this.pdfUrl1 = this.getMeetingRecordRes.confirmationUrl;
				this.pdfUrl2 = this.getMeetingRecordRes.evidenceFileUrl;
				this.getNumPages();
				console.log("pdfUrl1", this.pdfUrl1);
				console.log("pdfUrl2", this.pdfUrl2);
			}
		},
		created() {
			// this.openPdf(this.url);
			this.pdfUrl1 = this.getMeetingRecordRes.confirmationUrl;
			this.pdfUrl2 = this.getMeetingRecordRes.evidenceFileUrl;
			
		},
		mounted() {
			
		},
		methods: {
			getNumPages() {
				let loadingTask = PdfViewer.createLoadingTask(this.pdfUrl2)
				console.log("loadingTask", loadingTask);
				// 网上查询 都没有加promise执行的整页渲染 emmmm... 不知道他们怎么运行的
				loadingTask.promise.then(pdf => {
					// this.laoclUrl = loadingTask
					console.log("pdf", pdf);
					this.numPages = pdf.numPages
				}).catch((err) => {
					console.error('pdf加载失败')
				})
			},
			downloadPDF(type) {
				const url = type == '1' ? this.getMeetingRecordRes.confirmationUrl : this.getMeetingRecordRes
					.evidenceFileUrl; // PDF文件的网络路径
				// const filename = type == '1' ? '数据保全证书.pdf' : this.name + '.pdf'; // 下载文件的名称
				const filename = type == '1' ? '数据保全证书.pdf' : '数据保全详情.pdf'; // 下载文件的名称
				saveAs(url, filename);
				// const link = document.createElement('a');
				// link.href = this.pdfUrl;
				// link.setAttribute('download', 'file.pdf');
				// document.body.appendChild(link);
				// link.click();
			}
		},

	};
</script>
<style>
	.pdf-viewer {
		background-color: #fff;
		/* 设置背景颜色为白色 */
		color: #fff;
		/* 设置字体颜色为白色 */
	}

	.pdf-viewer .pdf-embed {
		background-color: #fff;
		/* 设置嵌入式PDF文件的背景颜色为白色 */
	}

	html {
		--iron-icon-height: 20px;
		--iron-icon-width: 20px;
		--viewer-icon-ink-color: rgb(189, 189, 189);
		--viewer-pdf-toolbar-background-color: rgb(50, 54, 57);
		--viewer-text-input-selection-color: rgba(255, 255, 255, 0.3);
	}

	#toolbar {
		align-items: center;
		background-color: var(--viewer-pdf-toolbar-background-color);
		color: #000;
		display: flex;
		height: var(--viewer-pdf-toolbar-height);
		padding: 0 16px;
	}
</style>
<style scoped lang="scss">
	.wrapper {
		height: auto;
	}

	.pdfBox {
		position: relative;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background: #000;
		overflow: hidden;
		z-index: 99;

		#previewPdf {
			height: 100vh;
		}
	}
</style>
